<template>
    <v-dialog 
    v-model="dialog"
    scrollable 
    persistent
    max-width="1200px"
    transition="dialog-transition">
    <template v-slot:activator="{ on }"> 
          <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                  <v-icon small exact-active-class="indigo" class="ma-2" v-on="{ ...tooltip, ...on }"
                      @click="getDataAnios()">
                      mdi-star-cog
                  </v-icon>
              </template>
              <span>Carga Manual Estrellas</span>
          </v-tooltip>
    </template> 
    <v-card :loading="loading">
      <v-card-title class="pa-0">
        <ModalTitle titulo="Carga Manual Estrellas" @cancelar="cancelar"/>
      </v-card-title>  
      <v-divider />
      <v-card-text>
        <div class="d-flex mt-2 mb-2">
          <AgregarHistorialEstrella :idInstalacion="id" :instalacion="instalacion" @recargaTabla="getDataAnios"/>
        </div>
        <v-data-table
          :headers="headers"
          :items="dataEstrellas"
          :items-per-page="5"
          no-data-text="no hay Datos"
          :footer-props="footerProps">
          <template v-slot:item.action="{ item }">
            <div class="d-flex flex-row justify-center">
              <ModHistorialEstrella :estrella="item" @recargaTabla="getDataAnios" />
            </div>         
          </template>
        </v-data-table>  
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="cancelar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>   
    </v-dialog>
</template>
<script>
import axios from "@/axios.js"
import ModalTitle from '@/components/utils/ModalTitleComponent'
import ModHistorialEstrella from '@/components/Estrellas/ModHistorialEstrella'
import AgregarHistorialEstrella from '@/components/Estrellas/AgregarHistorialEstrella'

export default{
    components: {
      ModalTitle,
      ModHistorialEstrella,
      AgregarHistorialEstrella
    },
    props: ["id", "instalacion"],
    created() {
      axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },     
    methods:{
      cancelar() {
        this.estrellasSeleccionadas = [];
        this.anios = [];
        this.cantEstrellasBlancas = 0;
        this.notaObtenida = 0;
        this.loading = false;
        this.dialog = false;
        this.inscrita = false;
      },
      getDataAnios(){ 
        this.loading = true;
            axios.get("/instalaciones/getHistorialEstrellas/"+this.id).then(response => {
                this.dataEstrellas = response.data;
                this.loading = false;
            }).catch(error => {
              if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
              } else {
                console.log(error);
                this.loading = false;
              }
            })
      },

    },
    data:() =>({
      dialog: false,
      loading: false,
      dataEstrellas: [],
      footerProps: {
        disableItemsPerPage: true,
        showFirstLastPage: true,
        firstIcon: "mdi-page-first",
        lastIcon: "mdi-page-last",
        prevIcon: "mdi-chevron-left",
        nextIcon: "mdi-chevron-right",
        itemsPerPageText: "Registros por página",
        itemsPerPageAllText: "Todos",
        showCurrentPage: true
      },
      headers: [
        { 
          text: "Acciones",
          value: "action",
          align: "center",
          align: 'center',
          width: '10%',
          sortable: false
        },
        {
          text: "Año",
          value: "anio",
          align: "center",
          sortable: true
        },
        {
          text: "Nota",
          value: "nota",
          align: "center",
          sortable: true
        },
        {
          text: "Estrellas Blancas",
          value: "cantidadEstrellasBlancas",
          align: "center",
          sortable: true
        },
        {
          text: "Estrella Verde",
          value: "estrellaVerde",
          align: "center",
          sortable: true
        },
        {
          text: "Estrella Plateada",
          align: "center",
          sortable: false,
          value: "estrellaPlateada"
        },
        {
          text: "Estrella Anaranjada",
          align: "center",
          sortable: false,
          value: "estrellaAnaranjada"
        },
        {
          text: "Inscrita pero no presentó Informe Final",
          align: "center",
          sortable: false,
          value: "inscrita"
        }
      ],
    }),


}

</script>